import './Icon.css';
export var container = '_vb5blu0-2-0-1';